export default __webpack_public_path__ + "static/media/icon_done.71bd535e.svg";